module.exports = __webpack_public_path__ + "pc/img/career-designer.6c3ba14b.png";